/* eslint-disable max-len */
export default function PoliciesPage() {
  return (
    <div className="grid grid-cols-12 mx-14 gap-6 mt-8 pt-10 ">
      <div className="col-span-12 row-start-1  p-5 bg-white rounded-lg">

        <div className="page-content">

          <p><strong>CONTRATO DE LICENCIAMIENTO PARA USO EXCLUSIVO DE APLICATIVO WEB Y/O HERRAMIENTA NUMEROLOGICA ARITHMAX (EN ADELANTE “EL CONTRATO”) CELEBRADO POR UNA PARTE EN SU CARÁCTER DE LICENCIATARIO, LA PERSONA QUE APARECE EN EL REGISTRO DE CUENTA Y USUARIO FORMULADO EN&nbsp; APP.NUMEROLOGIA-COTIDIANA.COM EN LO SUCESIVO (EL “LICENCIATARIO”) Y POR LA OTRA PARTE EN SU CARÁCTER DE LICENCIANTE,&nbsp; ALPHACENTRO NUMEROLÓGICO, SOCIEDAD CIVIL, REPRESENTADO EN ESTE ACTO POR SU APODERADO LEGAL LA C. LAURA LUDIVINA RODRÍGUEZ MARTÍNEZ,&nbsp; A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ EL “NUMEROLOGIA COTIDIANA”, DENOMINADOS EN CONJUNTO COMO “LAS PARTES”, SUSCRIBEN DE CONFORMIDAD EL PRESENTE ACUERDO DE VOLUNTADES MEDIANTE EL USO DE MEDIOS DIGITALES EN LA CIUDAD DE MONTERREY, NUEVO LEÓN, MÉXICO A LA FECHA DE SU ACEPTACIÓN ELECTRONICA AL TENOR DE LAS DECLARACIONES Y CLÁUSULAS SIGUIENTES:</strong></p>

          <p><strong>DECLARACIONES</strong></p>

          <p>
            <strong>I.</strong>
            <strong> </strong>
            <strong>DECLARA EL LICENCIATARIO</strong>
          </p>

          <p>
            a) Que es una persona física o moral con capacidad jurídica basta y suficiente para obligarse en los términos del presente y sus anexos como los son sus
            <strong>TERMINOS Y CONDICIONES, AVISO DE PRIVACIDAD Y MANUAL DE USO DE APLICATIVO WEB.</strong>
          </p>

          <p>b) Que en caso de ser persona moral su apoderado legal, cuenta con facultades suficientes para la celebración del presente contrato, las cuales le fueron conferidas mediante fedatario público y la fecha no le han sido revocadas, modificadas y/o limitadas de manera o forma alguna.</p>

          <p>
            c) Que es su voluntad suscribir el presente acuerdo de voluntades con
            <strong>NUMEROLOGIA COTIDIANA</strong>
            {' '}
            de conformidad y al tenor de todos y cada uno de los puntos señalados en el presente contrato y sus anexos.
          </p>

          <p>d) Que cuenta con la capacidad técnica y económica, el conocimiento y experiencia para cumplir con los términos y condiciones del presente instrumento y sus anexos.</p>

          <p>e) Que se compromete en todo sentido estricto y amplio a dar cumplimiento en cuanto a todo lo que le toca al amparo de este contrato y sus anexos.</p>

          <p>
            f) Que a la aceptación y firma del presente ha leído cuidadosa y detalladamente el presente acuerdo de voluntades y sus anexos que forman parte integra del presente como lo son; los
            <strong>TERMINOS Y CONIDCIONES DEL APLICATIVO WEB, EL AVISO DE PRIVACIDAD DEL APLICATIVO WEB Y EL MANUAL DE USO DEL APLICATIVO WEB,</strong>
            {' '}
            todos contenidos para su conocimiento, lectura y aceptación en app.numerologia-cotidiana.com, en adelante los “Anexos”.
          </p>

          <p>
            II.
            <strong>DECLARA NUMEROLOGIA COTIDIANA POR CONDUCTO DE SU APODERADP LEGAL</strong>
            :
          </p>

          <p>a) Que es una sociedad debidamente constituida conforme a las leyes de los Estados Unidos Mexicanos, tal como lo acredita y señala la escritura pública No. 24,499, de fecha 09 de septiembre de 2016, emitida por el notario público No. 3, el Lic. Emilio Cárdenas Estrada, en la ciudad de Monterrey, Nuevo León.&nbsp;</p>

          <p>b) Que su representante y/o apoderado legal la C. LAURA LUDIVINA RODRÍGUEZ MARTÍNEZ cuenta con facultades suficientes para la celebración del presente contrato, las cuales le fueron conferidas mediante el documento constitutivo antes descrito, facultades que a la fecha no le han sido revocadas, modificadas y/o limitadas de manera o forma alguna;</p>

          <p>c) Que su domicilio para oír y recibir todo tipo de notificaciones es el señalado en FRANCISCO G. SADA, 2925, INTERIOR D, COLONIA CHEPEVERA, MONTERREY, NUEVO LEON.</p>

          <p>d) Que cuenta con Registro Federal de Contribuyentes ACN160909HV7</p>

          <p>e) Que es titular de todos los derechos patrimoniales y morales del APLICATIVO WEB y/o Herramienta Numerológica ARITHMAX, su marca, aviso comercial y en general todos aquellos derechos que le corresponden por su creación y registro.&nbsp;</p>

          <p>f) Que es titular de todos los derechos patrimoniales y morales Numerología Cotidiana® y en general todos aquellos derechos que le corresponden por su creación y registro.&nbsp;</p>

          <p>
            <strong>III. </strong>
            <strong />
            <strong>DECLARAN EN CONJUNTO “LAS PARTES”.</strong>
          </p>

          <p>
            <strong>a) </strong>
            Que aceptan y reconocen que el presente no supone ninguna relación de naturaleza laboral, ni presente, pasada o futura, por lo que dejan claramente señalado que la única relación existente entre ambas partes es de naturaleza comercial y misma que atiende únicamente a lo señalado y ratificado en el presente documento y sus anexos.&nbsp;
          </p>

          <p>b) Que la presente es aceptada, reconocida y firmada mediante el uso de mecanismos digitales para su validación como lo son “checkbox” o “casilleros de aceptación” en formato digital en el enlace APP.NUMEROLOGIA-COTIDIANA.COM</p>

          <p>c) Que los anexos forman parte integral del presente y son estrictamente necesarios para la consumación del presente acuerdo de voluntades.</p>

          <p>
            d) Que suscriben el presente para el otorgamiento de una licencia de uso del aplicativo web y/o herramienta numerológica
            <strong>ARITHMAX</strong>
            {' '}
            al tenor de las cláusulas siguientes:&nbsp;
          </p>

          <p><strong>CLÁUSULAS&nbsp;</strong></p>

          <p>
            <strong>PRIMERO: OBJETO DEL PRESENTE</strong>
            {' '}
            <strong>Y DEFINICIONES.</strong>
            {' '}
            – Las partes reconocen que el objeto y fin del presente contrato es conceder en favor del
            {' '}
            <strong>LICENCIATARIO</strong>
            {' '}
            la
            {' '}
            <strong>AUTORIZACIÓN</strong>
            {' '}
            no exclusiva, limitada, onerosa, revocable y no transferible para el uso y aprovechamiento del
            {' '}
            <strong>APLICATIVO WEB</strong>
            {' '}
            y/o la herramienta numerológica
            {' '}
            <strong>ARITHMAX,</strong>
            {' '}
            incluyendo cualquier tipo de recurso y/o contenido que se genere del uso normal del aprovechamiento de esta, como lo son: materiales digitales, textos, reportes, imágenes, marcas, métodos, avisos, entre otros.&nbsp;
          </p>

          <p>
            Que reconocen para si y frente a terceros y en especial para el entendimiento específico del presente, el apartado 2 de las
            <strong>DEFINICIONES</strong>
            {' '}
            señalado en el anexo de
            <strong>TERMINOS Y CONDICIONES</strong>
            {' '}
            del
            <strong>APLICATIVO WEB.</strong>
          </p>

          <p>
            Que, para efectos del presente, su aclaración y cumplimiento, se observará como propio de este contrato, todo lo señalado y referido en el anexo de
            <strong>TERMINOS Y CONDICIONES</strong>
            {' '}
            del
            <strong>APLICATIVO WEB, </strong>
            al cual se puede acceder a través del enlace app.numerologia-cotidiana.com y app.numerologia-cotidiana.com/terminos
          </p>

          <p>
            <strong>SEGUNDO. – DEL USO, APROVECHAMIENTO Y ALCANCES DE LA LICENCIA. – LA LICENCIA</strong>
            {' '}
            es otorgada en su favor, en su calidad de
            <strong> LICENCIATARIO</strong>
            {' '}
            de manera onerosa, no exclusiva, limitada, revocable y no transferible para el uso y aprovechamiento del
            {' '}
            <strong>APLICATIVO WEB</strong>
            {' '}
            y/o herramienta numerológica
            {' '}
            <strong>ARITHMAX</strong>
            , de forma personal o para uso de consultas numerológicas frente a terceros de conformidad a los siguientes:
          </p>

          <ol>
            <li>
              <strong>LA LICENCIA</strong>
              <em> </em>
              se transmite en su favor por parte de
              <strong>NUMEROLOGIA COTIDIANA,</strong>
              {' '}
              titular exclusivo de todos los derechos patrimoniales, derechos de propiedad intelectual, industrial, de derechos de autor y cualquier otro conexo u accesorio al
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              .
            </li>
          </ol>

          <ol start={2}>
            <li>
              Toda impartición de consultas numerológicas mediante el aprovechamiento del
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              , que el
              <strong>LICENCIATARIO</strong>
              {' '}
              efectúe para sí mismo o para terceros, deberán efectuarse de manera uniforme y con los métodos operativos, comerciales y/o de interpretación que establezca
              <strong>NUMEROLOGIA</strong>
              {' '}
              <strong>COTIDIANA</strong>
              {' '}
              en el
              {' '}
              <strong>MANUAL DE USO DEL APLICATIVO</strong>
              {' '}
              <strong>WEB</strong>
              {' '}
              y/o herramienta numerológica&nbsp;
              {' '}
              <strong>ARITHMAX</strong>
              , tendientes a mantener la calidad, prestigio e imagen de los contenidos, productos o servicios ofrecidos por
              {' '}
              <strong>NUMEROLOGIA COTIDIANA</strong>
              {' '}
              en el
              {' '}
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              {' '}
              <strong>ARITHMAX.</strong>
            </li>
          </ol>

          <ol start={3}>
            <li>
              EL
              <strong> LICENCIATARIO</strong>
              {' '}
              previo a la firma del presente, se obliga a leer y entender los
              <strong>TÉRMINOS Y CONDICIONES, AVISO DE PRIVACIDAD, MANUAL DE USO DEL APLICATIVO WEB</strong>
              , y demás lineamientos análogos emitidos por
              <strong>NUMEROLOGIA</strong>
              {' '}
              COTIDIANA para el correcto uso y aprovechamiento del
              <strong>APLICATVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              {' '}
              a fin de que este en su carácter de
              <strong>LICENCIATARIO </strong>
              los conozca y evalúe de forma razonada, de tal manera que esté consciente de que, al utilizar, navegar o registrarse en el
              <strong>APLICATIVO WEB</strong>
              {' '}
              se sujeta a toda la normativa de uso, aprovechamiento y conducta existentes o por existir incluyendo a las modificaciones que pudiesen realizarse sin previo aviso o consentimiento del LICENCIATARIO.
            </li>
          </ol>

          <ol start={4}>
            <li>
              La impartición de consultas numerológicas mediante el aprovechamiento de la
              <strong>LICENCIA DE USO</strong>
              {' '}
              y en general el
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              , no supone ni otorga derecho o facultad alguna al
              <strong>LICENCIATARIO</strong>
              {' '}
              para otorgar o conferir a sus clientes, proveedores, usuario y en general a cualquier tercero,&nbsp; organización, persona u empresa, licencia alguna que suponga el derecho de utilizar para su aprovechamiento y explotación económica o cualesquiera que fuera el fin, los recursos y materiales conferidos al
              <strong>LICENCIATARIO</strong>
              {' '}
              por virtud del presente contrato de licenciamiento. lo anterior sin perjuicio de las penas y/o daños y perjuicios de los cuales el
              <strong>LICENCIATARIO</strong>
              {' '}
              será responsables por el uso indebido y mal manejo de la licencia conferida en el presente acto.&nbsp;
            </li>
          </ol>

          <ol start={5}>
            <li>
&nbsp;El
              <strong>LICENCIATARIO</strong>
              , manifiesta y reconoce que,
              <strong>NUMEROLOGIA COTIDIANA</strong>
              , es el único titular exclusivo de los derechos patrimoniales y morales reconocidos por el derecho de autor y propiedad intelectual que existen tanto en México como en el extranjero, sobre el
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              ,&nbsp; incluyendo además y sin limitar, cualquier otro sea recibido a su favor por virtud de la
              <strong>LICENCIA DE USO</strong>
              {' '}
              y en general de la presente relación contractual, sin importar el tiempo lugar y modo en el que se hayan entregado para su aprovechamiento.&nbsp;
            </li>
          </ol>

          <ol start={6}>
            <li>
              El Licenciatario reconoce y acepta que, en cualquier consulta numerológica, publicidad, asesoría, consejería u actos de comercio en los que use y aproveche frente a terceros el
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              ,&nbsp; deberá dar crédito como autor a
              <strong>LAURA LUDIVINA RODRÍGUEZ/NUMEROLOGÍA COTIDIANA®/ ALPHACENTRO NUMEROLÓGICO, SOCIEDAD CIVIL</strong>
              , según se le indique por parte de
              <strong>NUMEROLOGIA COTIDIANA</strong>
              , incluyendo para ello cualquier publicación que se realice en medios electrónicos o cualquier otro del que se haga uso con fines de, explotación, promoción o publicidad.&nbsp;
            </li>
          </ol>

          <ol start={7}>
            <li>
              De igual forma el
              <strong>LICENCIATARIO</strong>
              {' '}
              se obliga a notificar a todos sus clientes, usuario, entre otros y respecto con las cuales participe como asesor, consultor, proveedor y demás análogos, que el o los resultados que se obtengan del uso y aprovechamiento del
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              ,&nbsp; no puede ser reproducido, fotocopiado o reproducido por medios electrónicos, ni por ningún otro medio para su explotación en el mercado y están sujetos a las leyes y acuerdos internacionales en materia de derechos de autor, reconociendo que son propiedad intelectual del titular del
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              . La protección respecto de los derechos de autor y propiedad intelectual no se limita únicamente al
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              , sino también a todos aquellos procedimientos, información, textos y experiencia utilizados para la instrucción del M
              <strong>ANUAL DE USOS DEL APLICATIVO WEB</strong>
              , y en general del uso y aprovechamiento de la herramienta numerológica
              <strong>ARITHMAX.</strong>
            </li>
          </ol>

          <ol start={8}>
            <li>
&nbsp;El uso indebido o copia de los
              <strong>TÉRMINOS Y CONDICIONES, AVISO DE PRIVACIDAD, MANUAL DE USO DEL APLICATIVO WEB</strong>
              {' '}
              y en general del
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX</strong>
              {' '}
              para cualquier otro tipo de negocio distinto al de las consultas numerológicas o fuera de las salvedades provistas y otorgadas en este contrato y sus accesorios, constituye un método de competencia desleal y por tanto un posible delito. El
              <strong>LICENCIATARIO</strong>
              {' '}
              reconoce y está de acuerdo con que cualquier tipo de dato y autorización conferido a este por virtud de la
              <strong>LICENCIA DE USO</strong>
              , sin limitación alguna, es propiedad privada y eso incluye sin limitar secretos de negocios que pertenecen a
              <strong>NUMEROLOGIA COTIDIANA</strong>
              , por tanto, el
              <strong>LICENCIATARIO</strong>
              {' '}
              se obliga a no reproducir, copiar o distribuir por cualquier medio impreso o electrónico cualquier información recibida por
              <strong>NUMEROLOGIA COTIDIANA</strong>
              , a las personas, empresas, grupos, organizaciones&nbsp; y/o terceros con los que genere comercio, siendo esta información por tanto, de uso exclusivo del
              <strong>LICENCIATARIO</strong>
              .
            </li>
          </ol>

          <ol start={9}>
            <li>
              Por consecuencia al párrafo anterior, la presente
              <strong>LICENCIA DE USO</strong>
              , es otorgada de forma limitada y únicamente para uso y beneficio del
              <strong>LICENCIATARIO</strong>
              , por tanto, no se extiende u otorga a terceros distintos a este. Si el
              <strong>LICENCIATARIO</strong>
              {' '}
              resulta ser una persona moral, las obligaciones de uso y aprovechamiento concedidas en el presente, su aviso de privacidad y términos y condiciones en general, se extenderán al personal autorizado por parte del
              <strong>LICENCIATARIO</strong>
              , por lo que desde este momento el LICENCIATARIO reconoce toda responsabilidad civil, mercantil o penal frente a
              <strong>NUMEROLOGIA COTIDIANA</strong>
              {' '}
              por el mal uso o uso indebido del
              <strong> APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX, </strong>
              que su personal autorizado pudiera generar.&nbsp;
            </li>
          </ol>

          <ol start={10}>
            <li>
              Si en cualquier momento el
              <strong>LICENCIATARIO</strong>
              {' '}
              no estuviera de acuerdo total o parcialmente con los
              <strong>TÉRMINOS Y CONDICIONES</strong>
              ,
              <strong>AVISO DE PRIVACIDAD, MANUAL DE USO DEL APLICATIVO WEB</strong>
              {' '}
              y en general cualquier normativa emitida por
              <strong>NUMEROLOGIA COTIDIANA</strong>
              {' '}
              para el uso de la herramienta numerológica
              <strong>ARITHMAX</strong>
              {' '}
              deberá abstenerse inmediatamente de usar el
              <strong>APLICATIVO WEB</strong>
              {' '}
              en cualquiera de sus partes o secciones. La renuncia al uso del
              <strong>APLICATIVO WEB</strong>
              {' '}
              por parte del
              <strong>LICENCIATARIO</strong>
              {' '}
              no supone ni supondrá reclamación o compensación económica alguna, por lo que desde este momento el LICENCIATARIO reconoce que no tendrá derecho a reclamar la devolución del pago de derechos correspondiente.&nbsp;
            </li>
          </ol>

          <p>
            <strong>TERCERA: PAGO DE DERECHOS. –&nbsp; </strong>
            El
            {' '}
            <strong>LICENCIATARIO</strong>
            {' '}
            deberá pagar por concepto de pago de derechos de la
            {' '}
            <strong>LICENCIA</strong>
            {' '}
            <strong>DE</strong>
            {' '}
            <strong>USO</strong>
            {' '}
            del
            {' '}
            <strong>APLICATIVO WEB</strong>
            {' '}
            y/o herramienta numerológica
            {' '}
            <strong>ARITHMAX</strong>
            {' '}
            la cantidad que corresponda y se señale en el apartado de registro del enlace app.numerologia-cotidiana.com. El monto que ahí se señale podrá variar de conformidad a las disposiciones de los titulares del
            {' '}
            <strong>APLICATIVO</strong>
            {' '}
            <strong>WEB</strong>
            {' '}
            pudiendo variar según cada caso de un
            {' '}
            <strong>LICENCIATARIO</strong>
            {' '}
            a otro.
          </p>

          <p>
            <strong>NUMEROLOGIA</strong>
            {' '}
            <strong>COTIDIANA</strong>
            {' '}
            asume que la información suministrada por el
            {' '}
            <strong>LICENCIATARIO</strong>
            {' '}
            para la obtención de su CUENTA, USUARIO y por ende
            {' '}
            <strong>LICENCIA</strong>
            {' '}
            <strong>DE</strong>
            {' '}
            <strong>USO</strong>
            {' '}
            es de carácter verídico, por lo que no será responsable frente a terceros de la información falsa o irregular que el
            {' '}
            <strong>LICENCIATARIO</strong>
            {' '}
            suministre en su registro.&nbsp;
          </p>

          <p>
            La falsedad de información, el fraude, robo de identidad o de tarjetas o cuentas bancarias es causa suficiente y basta para retirar y cancelar la
            <strong>LICENCIA</strong>
            {' '}
            <strong>DE</strong>
            {' '}
            <strong>USO</strong>
            {' '}
            por lo que, desde este momento,
            {' '}
            <strong>NUMEROLOGIA</strong>
            {' '}
            <strong>COTIDIANA</strong>
            {' '}
            se reserva tal derecho en caso de ser necesario.
          </p>

          <p>
            Sin perjuicio a lo anterior el
            <strong>LICENCIATARIO</strong>
            {' '}
            asume desde este momento frente a terceros y/o autoridad competente toda responsabilidad civil, penal, mercantil, fiscal y/o de cualquier naturaleza por la usurpación de datos, tanto personales como bancarios.&nbsp;
          </p>

          <p>
            <strong>CUARTA:&nbsp; VIGENCIA DE LA LICENCIA:</strong>
&nbsp; El termino o vigencia de la presente
            {' '}
            <strong>LICENCIA DE USO</strong>
            {' '}
            otorgada en este acto en favor del
            {' '}
            <strong>LICENCIATARIO</strong>
            , será (1) un año contado a partir de la firma y aceptación del presente contrato, los
            {' '}
            <strong>TÉRMINOS Y CONDICIONES</strong>
            ,
            {' '}
            <strong>AVISO DE PRIVACIDAD y MANUAL DE USO DEL APLICATIVO WEB </strong>
            puestos a disposiciones del
            {' '}
            <strong>LICENCIATARIO</strong>
            {' '}
            en app.numerologia-cotidiana.com.
          </p>

          <p>
            Al cumplirse al plazo o término de la vigencia, el
            <strong>LICENCIATARIO,</strong>
            {' '}
            tendrá la opción de renovar y/o actualizar la
            <strong>LICENCIA</strong>
            {' '}
            <strong>DE</strong>
            {' '}
            <strong>USO</strong>
            {' '}
            para lo cual habrá en su caso de firmar un nuevo acuerdo de voluntades con el titular de esta. el
            {' '}
            <strong>LICENCIATARIO</strong>
            {' '}
            reconoce y acepta que, los términos y condiciones, aviso de privacidad, manual de usos y pago de derechos del nuevo contrato podrán ser diferentes a los contenidos en el presente, por lo que queda a discreción y responsabilidad el
            {' '}
            <strong>LICENCIATARIO</strong>
            {' '}
            enterarse de los posibles cambios de ser el caso.&nbsp;
          </p>

          <p>
            <strong>CUARTA. –&nbsp; PROPIEDAD INTELECTUAL : </strong>
            Respecto a la propiedad intelectual del
            {' '}
            <strong>APLICATIVO WEB</strong>
            {' '}
            y/o herramienta numerológica
            {' '}
            <strong>ARITHMAX</strong>
            {' '}
            señalados o no en el presente incluyendo sin limitar cualquier tipo de contenido, programa, texto, proceso, imagen, marca, y demás susceptible de protección por ser considerados propiedad intelectual, secreto industrial, derecho de autor y demás relativo a la propiedad exclusiva de
            {' '}
            <strong>NUMEROLOGIA COTIDIANA</strong>
            , “LAS PARTES” acuerdan en apegarse a lo descrito en el punto 8 del apartado propiedad intelectual&nbsp; de los
            {' '}
            <strong>TERMINOS Y CONDICIONES del APLICATIVO WEB</strong>
            .
          </p>

          <p>
            <strong>QUUNTA. – MOTIVOS DE TERMINACION, CANCELACIÓN Y/O REVOCACIÓN DE LA LICENCIA:</strong>
            {' '}
            Será motivo de terminación, cancelación, recisión y/o revocación de la
            {' '}
            <strong>LICENCIA DE USO</strong>
            , los siguientes:
          </p>

          <ol>
            <li>La terminación simple y natural por vencimiento de contrato.</li>
            <li>La terminación adelantada por solicitud de cualquiera de las partes solo siempre y cuando se de por aviso a la otra parte con 45 días de anticipación a los medios de notificación señalados en este contrato.</li>
            <li>La recisión de este contrato por cualquiera de las violaciones al presente, sus términos y condiciones, aviso de privacidad, manual de uso, etc.&nbsp;</li>
            <li>La falsedad, engaño, ocultamiento y demás vicios ocultos que pudiesen surgir tras el acuerdo a lo aquí pactado. Este motivo dará lugar inmediato a la cancelación y/o revocación de la LICENCIA DE USO.</li>
            <li>Acuerdo entre las partes.</li>
            <li>
              El uso indebido del
              <strong>APLICATIVO WEB</strong>
              {' '}
              y/o herramienta numerológica
              <strong>ARITHMAX.</strong>
            </li>
            <li>
              La competencia desleal y la asociación, vinculo o creación de cualquier otra empresa, organización, persona física y demás relativos que busquen o hagan cualquier programa similar al
              <strong>APLICATIVO WEB.</strong>
            </li>
            <li>El inicio de un proceso de solución de conflicto entre las partes contratantes, y;</li>
            <li>En general, el incumplimiento a cualquier otra obligación pactada en el presente contrato&nbsp;</li>
          </ol>

          <p>
            <strong>SEXTA. – SOLUCION DE CONFLICTOS: </strong>
&nbsp;Para la solución de conflictos controversia, diferencia o reclamación que surja, incluyendo en particular y sin limitar, su formación, validez, obligatoriedad, divulgación, confidencialidad, interpretación, ejecución, incumplimiento y demás, así como las reclamaciones extracontractuales pactadas y no pactadas en el presente serán sometidas a los tribunales de la ciudad de Monterrey, Nuevo León y de forma supletoria los tribunales de la Ciudad de México.&nbsp;
          </p>

          <p>Por últimos se acepta por las partes que, si alguna disposición del presente contrato, sus términos y condiciones, aviso de privacidad, etc, fuera declarada como inválida por autoridad competente, el resto de estas permanecerán vigentes y serán obligatorias en su cumplimiento.&nbsp;&nbsp;</p>

          <p>
            <strong>SEPTIMA. – RESPONSABILIDAD Y ALCANCES LEGALES: </strong>
            Las partes sin perjuicio de las disposiciones legales aplicables, y respetando el principio de voluntariedad que impera en la presente relación, aceptan y están de acuerdo en que el contenido del presente contrato como sus anexos, es decir; los términos y condiciones del Aplicativo Web, su Aviso de Privacidad y Manual de Uso, son&nbsp; la más amplia voluntad entre estas, por lo que, con independencia de las responsabilidades ya señaladas a lo largo del cuerpo de este documento y sus anexos, las partes se comprometen y obligan a sacar por todo aquello que se pudiera presentar más allá de los alcances del presente contrato, mencionando sin limitar cualquier tipo de responsabilidad, civil, penal, mercantil, fiscal, de propiedad intelectual, derechos de autor y en general de la materia que se trate, libre y en paz a la contra parte.&nbsp; Por lo tanto, desde este momento la parte que cause la molestia se obliga a pagar a la parte molestada, los gatos y/o erogaciones económicas que, por motivos de demandas, acusaciones y en general cualquier acto de molestia en que esta sea vea involucrada.&nbsp;
          </p>

          <p>
            Por lo anterior, el “Licenciatario”, se obliga dese este momento a indemnizar, defender y sacar en paz y a salvo a Alphacentro Numerológico, Sociedad Civil de cualquier responsabilidad que se le trate de asignar que derive de cualquier reclamación, queja o demanda de terceros a los que les haya o vaya a impartir consultas numerológicas mediante el uso y aprovechamiento de la licencia otorgada en el presente acto.&nbsp;
            <br />
            <strong>EL PRESENTE CONTRATO Y SUS ANEXOS REPRESENTAN LA VERDAD ENTRE LAS PARTES Y ES FIRMADO Y ACEPTADO MEDIANTE EL USO DE MEDIO DIGITALES PARA SU ACREDITACION Y ACEPTACIÓN A LA FECHA DE SU ACEPTACION EN EL ENLACE </strong>
            <strong>APP.NUMEROLOGIA-COTIDIANA.COM</strong>
          </p>

        </div>

        <div className="page-content">

          <p>
            <strong>TERMINOS Y CONDICIONES PARA EL USO Y APROVECHAMIENTO DE LA HERRAMIENTA NUMEROLOGICA</strong>
            {' '}
            “
            <strong>ARITHMAX” EN SU MODALIDAD DE PLATAFORMA DIGITAL, APLICATIVO Y/O SITIO WEB MEDIANTE ACCESO EN APP.NUMEROLOGIA-COTIDIANA.COM.</strong>
          </p>

          <ol><li><strong>PREAMBULO</strong></li></ol>

          <p>
            Mediante el presente se pone al público y usuarios en general, la información relevante y que tiene que saber toda persona para el aprovechamiento y uso de la
            <strong>PLATAFORMA DIGITAL, APLICATIVO Y/O SITIO WEB “ARITHMAX”</strong>
            {' '}
            mediante acceso en app.numerologia-cotidiana.com en adelante el (“
            <strong>APLICATIVO WEB</strong>
            ”), propiedad de ALPHACENTRO NUMEROLÓGICO, SOCIEDAD CIVIL y/o LAURA RODRIGUEZ MARTINEZ, (separada o conjuntamente como “NUMEROLOGIA COTIDIANA”)
          </p>

          <ol start={2}><li><strong>DEFINICIONES</strong></li></ol>

          <p>
            <strong>ARITHMAX: </strong>
            Nombre comercial y/o marca registrada en México y en el mundo por ALPHACENTRO NUMEROLÓGICO, SOCIEDAD CIVIL, y/o LAURA RODRIGUEZ MARTINEZ para su aprovechamiento, comercialización y explotación según sea el caso. Todos derechos están reservados.
          </p>

          <p>
            <strong>NUMEROLOGIA COTIDIANA</strong>
            : Nombre comercial y/o marca registrada en México y en el mundo por ALPHACENTRO NUMEROLÓGICO, SOCIEDAD CIVIL, y/o LAURA RODRIGUEZ MARTINEZ para su aprovechamiento, comercialización y explotación según sea el caso. Todos los derechos están reservados.
          </p>

          <p>
            <strong>PLATAFORMA DIGITAL, APLICATIVO Y/O SITIO WEB</strong>
            : Aplicación ejecutable por medio de un servidor web mediante el uso de cualquier navegador (Chrome, Safari, Edge, Firefox, etc.) y conexión a internet, que almacenan información de una CUENTA relacionada y previamente registrada por persona física o moral en el enlace digital app.numerologia-cotidiana.com y que sirve para efectos de comercio como herramienta numerológica para la generación de análisis y reportes de carácter informativo y/o especulativo.
          </p>

          <p>
            <strong>CUENTA: </strong>
            Será el significado que se le dará a todo registro hecho por persona física o moral en el APLICATIVO WEB para formar parte de su cartera de usuarios, y que constará de un correo electrónico y contraseña para su validación e identificación.&nbsp;
          </p>

          <p>
            <strong>USUARIO:</strong>
&nbsp;Sujeto que tiene una interacción directa con el APLICATIVO WEB por contratación o periodo de prueba y que ha sido correctamente registrado, previo llenado de formularios y pago de derechos y por tanto vinculado a una CUENTA para su identificación y acceso al APLICATIVO WEB.
          </p>

          <p>La utilización, uso y navegación mediante registro previo de CUENTA en el APLICATIVO WEB por parte de cualquier persona, le atribuye la calidad de USUARIO con relación a lo descrito en el punto inmediato anterior, por tanto, ello implica su adhesión plena, voluntaria e incondicionada a lo establecido el presente acuerdo de Términos y Condiciones.&nbsp;</p>

          <p>
            <strong>PAGO DE DERECHOS:</strong>
            {' '}
            Es el pago en moneda nacional y/o extrajera que realiza una persona física o moral para obtener su LICENCIA DE USO y CUENTA para formar parte de la cartera de usuario del APLICATIVO WEB.
          </p>

          <p>
            <strong>LICENCIA DE USO</strong>
            : Autorización no exclusiva, limitada, no gratuita, revocable y no transferible para el uso y aprovechamiento del APLICATIVO WEB incluyendo cualquier tipo de recurso y/o contenido que se genere del uso normal de este, como lo son: materiales digitales, textos, imágenes, marcas, métodos, avisos, entre otros. Y que estará sujeta al registro previo para la creación de una CUENTA y USUARIO en el APLICATIVO WEB, así como al correspondiente PAGO DE DERECHOS y aceptación de los presentes TERMINOS Y CONDICIONES, así como su respectivo CONTRATO DE LICENCIAMIENTO, que se podrán descargar para su aceptación y conocimiento en: app.numerologia-cotidiana.com
          </p>

          <p>
            <strong>CONTRATO DE LICENCIAMIENTO:</strong>
            {' '}
            Será el contrato que el USUARIO deberá firmar por medios digitales para obtener de forma definitiva, absoluta y limitada la LICENCIA DE USO del APLICATIVO WEB, y que a su vez constituye el acuerdo más amplio entre el USUARIO y NUMEROLOGIA COTIDIANA al respecto del uso y aprovechamiento de la herramienta numerológica
            {' '}
            <strong>ARITHMAX.</strong>
          </p>

          <ol start={3}><li><strong>GENERALES</strong></li></ol>

          <p>
            Los Términos y Condiciones que a continuación se presentan (en adelante como, los “
            <strong>TÉRMINOS Y CONDICIONES</strong>
            ”) en su forma de anexo al
            <strong>CONTRATO DE LICENCIAMIENTO</strong>
            {' '}
            representan el acuerdo más amplio, suficiente y basto entre el
            <strong> USUARIO </strong>
            y
            <strong>NUMEROLOGIA COTIDIANA </strong>
            empresa constituida bajo el amparo de las leyes mexicanas, con domicilio para oír y recibir todo tipo de notificaciones en Calle
            <strong>FRANCISCO G. SADA, 2925, INTERIOR D, COLONIA CHEPEVERA, MONTERREY, NUEVO LEON</strong>
            . Al respecto del uso y aprovechamiento del
            <strong>APLICATIVO WEB.</strong>
          </p>

          <ol start={4}><li><strong>OBJETO Y FIN</strong></li></ol>

          <p>
            Los
            <strong>TÉRMINOS Y CONDICIONES</strong>
            , tienen como finalidad establecer las condiciones de uso y aprovechamiento del
            <strong>APLICATIVO WEB,</strong>
            {' '}
            así como los servicios que el
            <strong>USUARIO </strong>
            puede adquirir o encontrar dentro del
            <strong>APLICATIVO WEB</strong>
            {' '}
            como herramienta digital para fines de consultas numerológicas, mencionando sin limitar: numerología de parejas, análisis, vibración del tiempo, retornos anuales, tabla del destino, tabla de compatibilidad, numerología de grupos, pináculos, etc.&nbsp;
          </p>

          <ol start={5}><li><strong>DE LAS CONDICIONES, ACUERDOS Y COMPROMISOS GENERALES</strong></li></ol>

          <p>
            Será obligación del
            <strong>USUARIO</strong>
            {' '}
            la lectura y comprensión de los presentes
            <strong>TÉRMINOS Y CONDICIONES</strong>
            , a fin de que el USUARIO los conozca y evalúe de forma razonada, de tal manera que esté consciente de que, al utilizar, navegar o registrarse en el
            <strong>APLICATIVO WEB</strong>
            {' '}
            se sujeta a estos
            <strong>TÉRMINOS Y CONDICIONES</strong>
            {' '}
            incluyendo a las modificaciones que pudiesen realizarse sin previo aviso o consentimiento del USUARIO.
          </p>

          <p>
            Si en cualquier momento el USUARIO no estuviera de acuerdo total o parcialmente con estos
            <strong>TÉRMINOS Y CONDICIONES</strong>
            , deberá abstenerse inmediatamente de usar el
            <strong>APLICATIVO WEB</strong>
            {' '}
            en cualquiera de sus partes o secciones.
          </p>

          <p>
            El USUARIO está de acuerdo en que en diversas partes del
            <strong>APLICATIVO WEB</strong>
            {' '}
            podrá haber estipulaciones especiales o distintas a estas que, según sea el caso, sustituirán, complementarán y/o modificarán los
            <strong>TÉRMINOS Y CONDICIONES</strong>
            , (en lo sucesivo las “Condiciones Específicas”), por tal razón resulta indispensable que el USUARIO las revise y lea previamente en cada caso y de no estar total o parcialmente de acuerdo con ella o ellas, se abstenga de usar la parte o sección del
            <strong>APLICATIVO WEB</strong>
            {' '}
            que corresponda para este caso.
          </p>

          <p>En caso de que el USUARIO utilice la parte regulada se entenderá que se somete total e incondicionalmente a ellas.&nbsp;</p>

          <ol start={6}><li><strong>DEL ACCESO, PUBLICIDAD Y USO DEL APLICATIVO WEB</strong></li></ol>

          <p>
            El acceso y utilización del
            <strong>APLICATIVO WEB, </strong>
            será responsabilidad única y exclusiva del USUARIO, será de carácter oneroso, limitado y apegado en todo momento a lo señalado a estos
            <strong>TERMINOS Y CONDICIONES,</strong>
            {' '}
            el
            <strong>CONTRATO DE LICENCIAMIENTO</strong>
            , las “Condiciones Específicas” y/o cualquier otro lineamiento de uso señalado en app.numerologia-cotidiana.com y/o por NUMEROLOGIA COTIDIANA.&nbsp;
          </p>

          <p>El USUARIO acepta y reconoce que todo acceso al APLICATIVO WEB deberá ser mediante el uso de internet y equipo de cómputo, tableta digital, celular u otro que por sus características análogas y/o de tecnología le permita a este (USUARIO) el acceso mediante servidor al APLICATIVO WEB o enlace app.numerologia-cotidiana.com.</p>

          <p>
            El
            <strong>USUARIO</strong>
            {' '}
            reconoce y acepta que el uso del APLICATIVO WEB y de los CONTENIDOS es bajo su exclusiva y estricta responsabilidad cuando sean usados para sí mismo o para terceros, por lo que acepta y manifiesta que, NUMEROLOGIA COTIDIANA no será en ningún momento y bajo ninguna circunstancia, responsable por cualquier interpretación que se haga para sí mismo o para terceros del APLICATIVO WEB y su CONTENIDO, por los desperfectos o problemas que se presentaran en el equipo electrónico o de cómputo (hardware) o programas de cómputo (software) que utilice el USUARIO para acceder o navegar en internet o para efecto de acceder el APLICATIVO WEB. Tampoco será responsable de la utilización, adaptación, aprovechamiento, vigencia, cancelación, revocación, extinción y demás análogas, respecto de la LICENCIA DE USO para la utilización del APLICATIVO WEB.&nbsp;&nbsp;
          </p>

          <p>
            NUMEROLOGIA COTIDIANA no se hace responsable por los virus y otros elementos dañinos que pudieran afectar al equipo electrónico y de acceso que hubiese utilizado el USUARIO para navegar en el APLICATIVO WEB ya que este no controla y no garantiza la ausencia de virus en la red ni la ausencia de otros elementos dañinos que puedan producir alteraciones en el sistema informático del
            <strong>USUARIO </strong>
            (software y/o hardware) o en los documentos electrónicos y ficheros almacenados en su sistema computacional, etc.&nbsp;
          </p>

          <p>NUMEROLOGIA COTIDIANA al ser una sociedad de carácter privado, independiente y ajena a partidos políticos y religiosos, no permite la publicación de contenidos que contravengan a este carácter y se reserva el derecho de aceptar publicar o sugerir sitios, subsitios o material ajenos a los valores institucionales de NUMEROLOGIA COTIDIANA.</p>

          <p>De la misma forma, NUMEROLOGIA COTIDIANA no será responsable del acceso a cualquier sitio y/o subsitio en Internet, aplicación móvil y demás ajeno al APLICATIVO WEB y en general ajeno a NUMEROLOGIA COTIDIANA al que el USUARIO podría o tenga acceso derivado de las promoción y ofertas generadas y hospedadas en el APLICATIVO WEB por terceros en virtud de un contrato o relación comercial o convenio de publicidad.&nbsp;</p>

          <p>Por lo anterior, el USUARIO reconoce que, NUMEROLOGIA COTIDIANA no es, ni será responsable del origen, los usos y destinos de dichos vínculos, sitios de internet, aplicaciones móviles y demás relativos. Por tanto, NUMEROLOGIA COTIDIANA no asume ninguna responsabilidad de dichos sitios, ni de sus contenidos ajenos, ni acepta cargo alguno por publicidad, aun y cuando cuente con un contrato previamente firmado por las partes para tal efecto.&nbsp;</p>

          <ol start={7}><li><strong>RESPONSABILIDADES Y COMPORTAMIENTOS DEL USUARIO</strong></li></ol>

          <p>
            El
            <strong>USUARIO</strong>
            {' '}
            desde este momento acepta y reconoce que,
            <strong>NUMEROLOGIA COTIDIANA</strong>
            {' '}
            no será responsable del uso, aprovechamiento y/o explotación que le dé el USUARIO a la herramienta numerológica
            <strong>ARITHMAX y/o APLICATIVO WEB </strong>
            frente a terceros, por tanto; desde este momento, el
            <strong>USUARIO</strong>
            <strong><em> </em></strong>
            se compromete a sacar en paz a NUMEROLOGIA COTIDIANA respecto de cualquier acto de molestia, demanda, reclamación y demás referente al aprovechamiento, utilización, uso, consumo, etc. Del APLICATIVO WEB como herramienta numerológica para si mismo y frente a terceros.&nbsp;
          </p>

          <p>
            El
            <strong>USUARIO</strong>
            <strong><em> </em></strong>
            acepta y reconoce que, deberá abstenerse de utilizar y aprovechar de manera indebida los contenidos, como imágenes, textos, pináculos, reportes, entre otros (en adelante los
            {' '}
            <strong>CONTENIDOS</strong>
            ) que se encuentren en el
            {' '}
            <strong>APLICATIVO WEB</strong>
            {' '}
            o que emanen de este como medio de consulta numerológica, por tanto, desde este momento acepta y reconoce que, todos los contenidos a los que pudiera tener acceso por virtud del Registro al APLICATIVO WEB y en general por concepto del uso de su respectiva
            {' '}
            <strong>LICENCIA DE USO</strong>
            {' '}
            será única y exclusivamente para los fines señalados por NUMEROLOGICA COTIDIANA en el presente u otros lineamientos.&nbsp;
          </p>

          <p>En consecuencia, a lo anterior, el USUARIO se obliga a usar los contenidos y los elementos utilizados en el APLICATIVO WEB de forma diligente, correcta y lícita, y en particular, se compromete a abstenerse de: (1) utilizar los CONTENIDOS de forma, con fines o efectos contrarios a la ley, al orden público y a lo establecido por el NUMEROLOGIA COTIDIANA, (2) copiar, difundir, modificar, reproducir con fines distintos a lo señalado en la LICENCIA DE USO, distribuir o utilizar de cualquier forma distinta a lo aquí expresamente señalado con o sin fines de lucro los CONTENIDOS y los demás elementos utilizados en el APLICATIVO WEB a menos que cuente con la autorización expresa y por escrito de NUMEROLOGIA COTIDIANA; (3) modificar o manipular las marcas, logotipos, avisos comerciales, nombres comerciales y signos distintivos contenidos en el APLICATIVO WEB y en general todos aquellos propiedad de NUMEROLOGIA COTIDIANA y/o Laura Ludivina Rodriguez Martinez, salvo que cuente con su autorización por escrito (4) suprimir, eludir o modificar los CONTENIDOS y los elementos utilizados en el APLICATIVO WEB así como los dispositivos técnicos de protección, o cualquier mecanismo o procedimiento establecido en el APLICATIVO WEB como lo son sin limitar su aviso de privacidad y demás análogos.</p>

          <ol start={8}><li><strong>PROPIEDAD INTELECTUAL Y DERECHOS DE AUTOR</strong></li></ol>

          <p>
            Desde este momento el USUARIO acepta y reconoce que toda la
            <strong>PROPIEDAD INTELECTUAL</strong>
            {' '}
            y los elementos utilizados en el APLICATIVO WEB, los CONTENIDOS, entre otros. Se encuentran debidamente registrados y protegidos bajo las autoridades y leyes correspondientes en México bajo titularidad y en favor de NUMEROLOGIA COTIDIANA y/o Laura Ludivina Rodriguez Martinez, por tanto, el USUARIO se obliga a respetar todos los derechos de la Propiedad Intelectual y Derechos de Autor que conforme a derecho han sido y serán otorgados en favor de NUMEROLOGIA COTIDIANA y/o Laura Ludivina Rodriguez Martinez, sin perjuicio de las penas de carácter civil o penal en las que pudiera incurrir por el incumplimiento a la presente cláusula.&nbsp;
          </p>

          <p>El USUARIO reconoce el alcance legal del presente, por lo que manifiesta su expresa conformidad al respecto del uso de la PROPIEDAD INTELECTUAL contenida o que emane del APLICATIVO WEB como lo son Imágenes, textos, gráficos, análisis, reportes, marcas, avisos comerciales, entre otros.</p>

          <p>Para efectos del presente, se entenderá por PROPIEDAD INTELECTUAL todas las marcas registradas y/o usadas en México o en el extranjero por NUMEROLOGIA COTIDIANA, así como todo derecho sobre invenciones (patentadas o no), diseños industriales, modelos de utilidad, información confidencial, nombres comerciales, avisos comerciales, reservas de derechos, nombres de dominio,&nbsp; así como todo tipo de derechos patrimoniales sobre obras y creaciones protegidas por derechos de autor y demás formas de propiedad industrial o intelectual reconocida o que lleguen a reconocer las leyes correspondientes en México y en el extranjero.</p>

          <ol start={9}><li><strong>DURACIÓN Y VIGENCIA&nbsp;</strong></li></ol>

          <p>
            El uso del
            <strong>APLICATIVO WEB,</strong>
            {' '}
            así como el aprovechamiento de los
            <strong>CONTENIDOS</strong>
            , tendrá una duración limitada de acuerdo con el contrato de
            <strong>LICENCIA DE USO</strong>
            , sin embargo, en caso de violación a los presentes términos y condiciones y/o casos enunciados más adelante, NUMEROLOGIA COTIDIANA podrá dar por terminada, suspender o interrumpir en cualquier momento y sin necesidad de previo aviso la utilización del APLICATIVO WEB sus servicios ofrecidos o los contenidos por las razones siguientes:&nbsp;
          </p>

          <ol>
            <li>
              Terminación natural del la
              <strong>LICENCIA DE USO</strong>
            </li>
            <li>Incumplimiento del Usuario a cualquier disposición planteada en los TERMINOS Y CONDICIONES del APLICATIVO WEB</li>
            <li>Uso indebido de los CONTENIDOS.</li>
            <li>Uso indebido de la PROPIEDAD INTELECTUAL</li>
            <li>Desprestigio ocasionado en perjuicio de NUMEROLOGIA COTIDIANA&nbsp;</li>
            <li>Quiebra o concurso mercantil legalmente declarado por autoridad competente.&nbsp;</li>
          </ol>

          <ol start={10}><li><strong>DATOS PERSONALES&nbsp;</strong></li></ol>

          <p>
            Para utilizar o gozar de los CONTENIDOS y en general del APLICATIVO WEB, es necesario que el USUARIO proporcione previamente a NUMEROLOGIA COTIDIANA mediante llenado de formularios en el enlace electrónico app.numerologia-cotidiana.com. ciertos datos de carácter personal (en adelante
            <strong>DATOS PERSONALES</strong>
            ) que NUMEROLOGIA COTIDIANA podrá administrar automatizadamente o no, de conformidad al
            <strong>AVISO DE PRIVACIDAD</strong>
            {' '}
            de que NUMEROLOGIA COTIDIANA al cual el USUARIO podrá tener acceso para su información y conocimiento mediante el siguiente enlace: app.numerologia-cotidiana.com/terminos
          </p>

          <p>
            El USUARIO al acceder al APLICATIVO WEB o a cualquiera de los CONTENIDOS ahí ofrecidos, acepta y reconoce que, los DATOS PERSONALES requeridos, son necesario para los fines USO del APLICATIVO WEB u obtención de la LICENCIA DE USO correspondiente, por lo tanto, el USUARIO está autorizando en la confirmación de los presentes TERMINOS Y CONDICIONES que, NUMEROLOGIA COTIDIANA acceda y administre los DATOS PERSONALES, incluyendo los DATOS PERSONALES SENSIBLES del USUARIO de conformidad a lo establecido en el
            <strong>AVISO DE PRIVACIDAD</strong>
            {' '}
            de&nbsp;
            <strong>NUMEROLOGIA COTIDIANA</strong>
            .&nbsp;
          </p>

          <p>
            El USUARIO se obliga a proporcionar DATOS PERSONALES verdaderos y fidedignos incluyendo los DATOS PERSONALES SENSIBLES que correspondan, y en caso de que deseara no darlos, o no estuviera de acuerdo con su uso y administración según el AVISO DE PRIVACIDAD de
            <strong>NUMEROLOGIA COTIDIANA</strong>
            , deberá abstenerse de usar, aprovechar, navegar u acceder al APLICATIVO WEB.&nbsp;
          </p>

          <p>
            En caso de que el USUARIO compartiera información falsa o confusa, a
            <strong>NUMEROLOGIA COTIDIANA</strong>
            , podrá negarle el acceso al APLICATIVO WEB y sus CONTENIDOS.&nbsp;
          </p>

          <p>
            Por el hecho de proporcionar sus DATOS PERSONALES, el USUARIO está autorizando a
            <strong>NUMEROLOGIA COTIDIANA</strong>
            {' '}
            a dar a conocer a cualquier autoridad competente la información respectiva, en caso de que ésta sea solicitada por los medios jurídicos adecuados.&nbsp;
          </p>

          <p>
            <strong>NUMEROLOGIA COTIDIANA</strong>
            {' '}
            no compartirá información personal alguna que haya sido proporcionada por terceros diferentes al USUARIO a menos que sea requerida por autoridad competente mediante los medios jurídicos adecuados.&nbsp;
          </p>

          <p>Del mismo modo, el USUARIO reconoce que, será este el único responsable del trato y manejo de todo tipo de información personal y sensible que este pueda recabar de terceros ajenos a NUMEROLOGIA COTIDIANA, por lo que desde este momento saca en paz NUMEROLOGIA COTIDIANA de cualquier demanda o recurso que pueda ser interpuesto en contra NUMEROLOGIA COTIDIANA.&nbsp;</p>

          <p>Desde este momento, el USUARIO acepta y reconoce que tiene y queda prohibido la divulgación al publico de cualquier tipo de información confidencial o datos personales de terceros ajenos a NUMEROLOGIA COTIDIANA como lo son sus clientes, proveedores, socios y en general cualquier persona que sea consultada en términos numerológicos mediante el aprovechamiento del APLICATIVO WEB y/o herramienta numerológica por el USUARIO.&nbsp;</p>

          <p>El USUARIO podrá acceder, rectificar, cancelar u oponerse al tratamiento de sus datos personales y datos personales sensibles que se obtengan de los registros y archivos para la obtención de su LICENCIA DE USO o bien, revocar su consentimiento para el uso de los mismos, presentando su solicitud por escrito en el domicilio de NUMEROLOGIA COTIDIANA o vía correo electrónico según se señalan dichos datos en el apartado de CONTACTO del presente.&nbsp;</p>

          <ol start={11}><li><strong>AUTORIZACIONES</strong></li></ol>

          <p>
            <strong>NUMEROLOGIA COTIDIANA</strong>
            {' '}
            autoriza mediane la correspondiente
            {' '}
            <strong>LICENCIA DE USO</strong>
            , la autorización del USUARIO para que este en términos correspondientes de los presentes
            {' '}
            <strong>TÉRMINOS Y CONDICIONES</strong>
            {' '}
            y según lo señalado en el contrato de
            {' '}
            <strong>LICENCIA DE USO,</strong>
            {' '}
            acceda al
            {' '}
            <strong>APLICATIVO WEB</strong>
            {' '}
            y los
            {' '}
            <strong>CONTENIDOS</strong>
            {' '}
            ahí compartidos para que los utilice y use a su conveniencia para si o para terceros de forma gratuita u onerosa sin limitación alguna más allá de los presentes
            {' '}
            <strong>TERMINOS Y CONDICIONES</strong>
            .
          </p>

          <p>El USUARIO, con relación a lo señalado en el apartado 10 del presente de los DATOS PERSONALES, autoriza desde este momento y sin lugar a dudas a que NUMEROLOGIA COTIDIANA revise, resguarde y maneje según su aviso de privacidad app.numerologia-cotidiana.com/terminos, los datos personales propios, señalando sin limitar, nombres, direcciones, teléfono, correo electrónico, datos bancarios, datos de tarjetas bancarias, etc.&nbsp;</p>

          <ol start={12}><li><strong>LEGALES</strong></li></ol>

          <p>
            En caso de que, cualquier término, condición o estipulación contenida en los presentes
            <strong>TÉRMINOS Y CONDICIONES </strong>
            se determine ineficaz, ilegal o sin efecto, el mismo podrá ser excluido del cuerpo del presente y el restante continuará en vigor y efecto en forma tan amplia como en derecho proceda.
          </p>

          <p>
            <strong>NUMEROLOGIA COTIDIANA</strong>
            {' '}
            no será responsable de los daños, perdidas, lesiones y/o cualquier tipo de resultado que se genere de la interpretación de la información o contenidos que el USUARIO y/o terceros ajenos a este o NUMEROLOGIA COTIDIANA como lo son clientes del USUARIO sus proveedores, entre otros, realicen del CONTENIDO del APLICATIVO WEB.
          </p>

          <p>
            <strong>NUMEROLOGIA COTIDIANA </strong>
            tampoco será y es responsable en ninguna circunstancia de las interpretaciones, consultas, servicios, reportes, consejos, estimaciones y demás análogas que el USUARIO efectúe mediante el uso de la herramienta numerológica
            {' '}
            <strong>ARITHMAX y/o APLICATIVO WEB </strong>
            en general, por lo que desde este momento asume al respecto de dichos actos o resultados, total responsabilidad.&nbsp;
          </p>

          <p>
            <strong>NUMEROLOGIA COTIDIANA</strong>
            {' '}
            sugiere al
            {' '}
            <strong>USUARIO</strong>
            {' '}
            y por conexión a todo aquel que de alguna forma obtenga parcial o totalmente contenido del APLICATIVO WEB y/o la herramienta numerológica ARTHIMAX que,
            {' '}
            <strong>NO </strong>
            tome en serio o literalmente las interpretaciones que pueda recibir o deducir del uso de la herramienta numerológica
            {' '}
            <strong>ARITHMAX y/o APLICATIVO WEB, </strong>
            sean de carácter
            <strong> </strong>
            automatizado o no. Del mismo modo, se deja claro y se solicita a toda persona
            {' '}
            <strong>NO</strong>
            {' '}
            tomar ninguna decisión de vida, negocios, personales u otras considerando que la interpretación de los
            {' '}
            <strong>CONTENIDOS</strong>
            {' '}
            es cierta e infalible pues no lo son,
            {' '}
            <strong>SOLO UTILICE </strong>
            su sentido común y su propio juicio. En opinión de
            {' '}
            <strong>NUMEROLOGIA COTIDIANA</strong>
            {' '}
            el
            {' '}
            <strong>APLICATIVO WEB</strong>
            {' '}
            y/o la herramienta numerológica
            {' '}
            <strong>ARITHMAX</strong>
            {' '}
            <strong>NO</strong>
            {' '}
            predice eventos ni da consejos sobre qué acciones debe tomar o las decisiones que debe elegir con respecto a sus circunstancias actuales o futuras de la vida.
          </p>

          <p>En todo lo relacionado con la interpretación y cumplimiento de lo aquí dispuesto y el contrato de Licencia de Uso respectivo, por el sólo hecho de acceder al APLICATIVO WEB, el USUARIO acepta someterse a las leyes aplicables y a la jurisdicción de los tribunales competentes en Monterrey, Nuevo León, México, renunciado a cualquier otra jurisdicción que, por razón de sus domicilio presente o futuro, o por cualquiera otra razón pudiese corresponderles.</p>

          <p>Cualquier derecho que no se haya conferido expresamente en estos TERMINOS Y CONDICIONES Y/O EL CONTRATO DE LICENCIA DE USO, se considera y aceptan como reservados por NUMEROLOGIA COTIDIANA y/o Laura Ludivina Rodriguez Martinez.</p>

          <ol start={13}><li><strong>DE LAS COOKIES Y WEB BEACONS</strong></li></ol>

          <p>El acceso al APLICATIVO WEB puede implicar la utilización de cookies. Las cookies son pequeñas cantidades de información que se almacenan en el navegador utilizado por cada USUARIO para que el servidor recuerde cierta información que posteriormente pueda utilizar. Esta información permite identificarle a usted como un usuario del APLICATIVO WEB y permite guardar sus preferencias personales, así como información técnica para que usted pueda ingresar a su CUENTA.&nbsp;</p>

          <p>Aquellos usuarios que no deseen recibir cookies o quieran ser informados antes de que se almacenen en su ordenador, pueden configurar su navegador a tal efecto.</p>

          <p>El USUARIO puede especificar en su navegador qué cookies aceptara y cuáles no. En concreto, el USUARIO puede normalmente aceptar alguna de las siguientes opciones: rechazar las cookies de determinados dominios; rechazar las cookies de terceros; aceptar cookies como no persistentes (se eliminan cuando el navegador se cierra); permitir al servidor crear cookies para un dominio diferente. Además, los navegadores pueden también permitir a los usuarios ver y borrar cookies individualmente.</p>

          <p>Para cualquier duda al respecto de este tema se recomienda al USUARIO consultar para su formación y conocimiento fuentes confiables.&nbsp;</p>

          <p>El APLICATIVO WEB puede albergar también web beacons, también conocidos por “web bugs”. Estos sirven y se utilizan de una forma similar a las cookies. Además, los webs beacons suelen utilizarse para medir el tráfico de usuarios que visitan una página web y poder sacar un patrón de los usuarios de un sitio.</p>

          <p>NUMEROLOGIA COTIDIANA puede que mida el tráfico y modo de uso del APLICATIVO WEB mediante el uso de Google Analytics, esto puede requerir utilizar cookies o web beacons para analizar lo que sucede en el APLICATIVO WEB. En caso de dudas o requerir mayor información puede revisar la política de privacidad de Google.&nbsp;</p>

          <ol start={14}><li><strong>DATOS DE CONTACTO</strong></li></ol>

          <p>Domicilio: FRANCISCO G. SADA, 2925, INTERIOR D, COLONIA CHEPEVERA, MONTERREY, NUEVO LEON.</p>

          <p>Teléfono: 449-320-4316</p>

          <p>
            Correo:
            <a href="mailto:legal@numerologia-cotidiana.com">legal@numerologia-cotidiana.com</a>
          </p>

          <ol start={15}><li><strong>DE LA ACEPTACION DE LOS TERMINOS Y CONDICIONES</strong></li></ol>

          <p>El USUARIO a la aceptación de los presentes TERMINOS Y CONDICIONES mediante el uso digital de un “Checkbox” y/o “Casillero de Aceptación” que se facilita para su uso en app.numerologia-cotidiana.com. Reconoce que queda obligado para con él mismo, NUMEROLOGIA COTIDIANA y terceros de ser el caso, al cumplimiento especifico de todas las obligaciones aquí contenidos como también aquella de carácter especifico y/o señaladas en el contrato de Licencia de Uso y/o Aviso de Privacidad.</p>
          <div className="post-tags" />
          <div className="page-content">

            <p><strong>AVISO DE PRIVACIDAD&nbsp;</strong></p>

            <p>
              <strong>ALPHACENTRO NUMEROLÓGICO, SOCIEDAD CIVIL, y/o LAURA RODRIGUEZ MARTINEZ,</strong>
              {' '}
              conjunta y/o separadamente en adelante Numerología Cotidiana® con domicilio para oír y recibir todo tipo de notificaciones en,
              {' '}
              <strong>FRANCISCO G. SADA, 2925, INTERIOR D, COLONIA CHEPEVERA, MONTERREY, NUEVO LEON. </strong>
              Declara mediante el presente aviso estar comprometida con la protección de sus datos personales, al ser responsable de su uso, manejo y confidencialidad y al respecto, le informa lo siguiente:
            </p>

            <p><strong>¿PARA QUÉ FINES SE UTILIZAN SUS DATOS PERSONALES?</strong></p>

            <p>Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades y que son NECESARIAS para el uso del APLICATIVO WEB app.numerologia-cotidiana.com. el registro de su USUARIO y creación de respectiva CUENTA.</p>

            <ul>
              <li>Confirmar su identidad</li>
              <li>Verificar la información que nos proporciona</li>
              <li>Proveer acceso de APLICATIVO WEB</li>
              <li>Creación de su CUENTA</li>
              <li>Generación de reportes y análisis para fines informativos&nbsp;</li>
              <li>Gestionar los cobros correspondientes a la LICENCIA DE USO del APLICATIVO WEB</li>
            </ul>

            <p>De manera adicional, utilizamos su información personal para las siguientes finalidades que no son necesarias para el servicio de acceso solicitado, pero que nos permiten y facilitan brindar una mejor atención:</p>

            <ul>
              <li>Notificarle sobre nuevos servicios o productos que tengan relación con los ya contratados o adquiridos con NUMEROLOGIA COTIDIANA, así como cambios en los mismos;</li>
              <li>Elaborar estudios y programas necesarios para determinar hábitos de consumo;</li>
              <li>Realizar evaluaciones periódicas sobre nuestros productos y servicios; y,</li>
            </ul>

            <p>
              En caso de que no desee que sus datos personales se utilicen para estos fines secundarios, indíquelo al correo electrónico
              <a href="mailto:legal@numerologia-cotidiana.com">legal@numerologia-cotidiana.com</a>
              {' '}
              y/o teléfonos siguientes 449-320-4316 señalando lo siguiente según corresponda a cada caso.&nbsp;
            </p>

            <p>No consiento que mis datos personales se utilicen para los siguientes fines:</p>

            <ul>
              <li>Notificaciones sobre nuevos servicios o productos a los ya contratados o adquiridos, así como cambios en los mismos.</li>
              <li>Elaboración de estudios y programas necesarios para determinar hábitos de consumo.</li>
              <li>Evaluaciones periódicas sobre nuestros productos y servicios.</li>
            </ul>

            <p>La negativa para el uso de sus datos personales para estas finalidades no podrá ser un motivo para que le neguemos los servicios y productos que solicita o contrata con nosotros. Sin embargo, le sugerimos leer y comprender detalladamente los TERMINOS Y CONDICIONES del APLICATIVO WEB.&nbsp;</p>

            <p>En caso de que no manifieste su negativa, se entenderá que autoriza el uso de su información personal para dichos fines.</p>

            <p><strong>¿QUÉ DATOS PERSONALES SE UTILIZAN PARA LOS FINES ANTERIORES?</strong></p>

            <p>Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, utilizaremos lo siguientes datos personales: Nombre, fecha de nacimiento, teléfono celular, correo electrónico, datos bancarios, domicilios.</p>

            <p>No se recaban datos de carácter sensible.</p>

            <p><strong>¿CON QUIÉN COMPARTIMOS SUS DATOS PERSONALES?</strong></p>

            <p>Numerología Cotidiana®, no realiza transferencia de datos personales y, en caso de realizarla por los servicios que presta, se solicitará el consentimiento expreso del titular de estos.</p>

            <p><strong>¿CÓMO PUEDE EJERCER SUS DERECHOS ARCO O REVOCAR SU CONSENTIMIENTO AL USO DE SUS DATOS PERSONALES?</strong></p>

            <p>
              Usted podrá acceder, rectificar, cancelar u oponerse al tratamiento de sus datos personales que tenemos en nuestros registros y archivos, o bien, revocar su consentimiento para el uso de estos, presentado solicitud por escrito en nuestro domicilio o bien, vía correo electrónico:
              <a href="mailto:legal@numerologia-cotidiana.com">legal@numerologia-cotidiana.com</a>
              {' '}
              y/o teléfonos siguientes 449-320-4316
            </p>

            <p>
              Es importante informarle que su solicitud deberá contener, al menos, la siguiente información:
              <br />
              (i) Su nombre o el de su representante, domicilio u otro medio para comunicarle la respuesta;
              <br />
              (ii) Los documentos que acrediten su identidad, o en su caso, el de su representante;
              <br />
              (iii) La descripción clara y precisa de los datos personales respecto de los cuales busca ejercer su derecho; y,
              <br />
              (iv) Cualquier otro elemento o documento que facilite la localización de los datos personales.
            </p>

            <p>Asimismo, deberá acreditar su identidad mediante identificación oficial vigente o en caso de presentar su solicitud a través de su representante, a través de instrumento público, carta poder firmada ante dos testigos o declaración en comparecencia personal del titular.</p>

            <p>Nos comprometemos a darle respuesta en un plazo máximo de 20 días hábiles contados a partir del día en que recibimos su solicitud, misma que pondremos a su disposición en nuestro domicilio si presentó su solicitud en Numerología Cotidiana®, o bien, a través de correo electrónico si el ejercicio de derechos ARCO lo solicitó por este medio, previa acreditación de su identidad. Si solicita acceso a sus datos personales, la reproducción de éstos se llevará a cabo a través de copias simples, archivo electrónico, o bien, podrá consultarlos directamente en sitio. En caso de solicitar su derecho de rectificación, su solicitud deberá ir acompañada de la documentación que ampare la procedencia de lo solicitado.</p>

            <p>La persona encargada de atender las solicitudes ARCO, es:</p>

            <p>
              Nombre: Jesús Eduardo Acedo Cota, Correo:
              <a href="mailto:legal@numerologia-cotidiana.com">legal@numerologia-cotidiana.com</a>
              , Teléfono: 449-320-4316
            </p>

            <p><strong>¿CÓMO LE INFORMAREMOS SOBRE CAMBIOS AL PRESENTE AVISO DE PRIVACIDAD?</strong></p>

            <p>El aviso de privacidad puede sufrir modificaciones o actualizaciones, por lo cual, nos comprometemos a mantenerlo informado de tal situación a través de la página de Internet app.numerologia-cotidiana.com.</p>

            <p><strong>¿CÓMO CONTACTARNOS?</strong></p>

            <p>Si usted tiene alguna duda sobre el presente aviso de privacidad o nuestra política de privacidad, puede dirigirla a:</p>

            <p>
              Nombre: Jesús Eduardo Acedo Cota, Correo:
              <a href="mailto:legal@numerologia-cotidiana.com">legal@numerologia-cotidiana.com</a>
              , Teléfono: 449-320-4316
              <br />
              Domicilio: Francisco G. Sada, 2925, interior D, Colonia Chepevera, Monterrey, Nuevo León.
            </p>

            <p>Asimismo, ponemos a su entera disposición copias del presente aviso de privacidad en nuestro domicilio y en nuestro aplicativo web app.numerologia-cotidiana.com.</p>

            <p>Si usted considera que su derecho a la protección de datos personales ha sido vulnerado por alguna conducta de Numerología Cotidiana®, puede acudir ante el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI). Para mayor información visite www.inai.org.mx</p>

            <p>
              Numerología Cotidiana®
              <br />
              <a href="http://www.numerologia-cotidiana.com">www.numerologia-cotidiana.com</a>
            </p>

            <p>Francisco G. Sada, 2925, interior d, Colonia Chepevera, Monterrey, Nuevo León</p>
            <div className="post-tags" />
          </div>
        </div>
      </div>
    </div>

  );
}
